import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Title} from '@angular/platform-browser';
import {HttpErrorResponse} from '@angular/common/http';
import {DataService} from '../../../../Services/data.service';
import {BsToastService} from '../../../../Services/bs-toast-service';
import {AppConfigService} from '../../../../Services/app-config.service';
import {ReportPrintService} from '../../../../Services/report-print.service';
import {ConfirmDialogService} from '../../../../Services/confirm-dialog.service';
import {EmailModel} from '../../../../DataModels/email-model';
import {SendEmailModalComponent} from '../../../common/send-email-modal/send-email-modal.component';
import {Modal} from 'bootstrap';
import {DatePipe, DecimalPipe} from '@angular/common';

@Component({
  selector: 'app-bank-import-page',
  templateUrl: './bank-import-page.component.html',
  styleUrls: ['./bank-import-page.component.css'],
  standalone: false
})
export class BankImportPageComponent implements OnInit {

  @ViewChild(SendEmailModalComponent, {read: ElementRef}) private emailModalHost: ElementRef;

  reportDataToSendInEmail: EmailModel = new EmailModel();

  private storedFile: File | null = null;

  // History list state
  historyPage = 1;
  historyPageSize = 25;
  historyTotalRecords = 0;
  historyLoaded = false;

  vm: any = {
    // Tab control
    activeTab: 'history',       // 'history' | 'work' | 'ignore-rules'

    // Shared
    banks: [],
    bank_id: '',
    company_id: '',
    locations: [],

    // History tab
    historyList: [],
    historyAllList: [],
    historyDetail: null,
    historyStatusFilter: '',
    reverseConfirmImportId: null,
    reversing: false,

    // Work tab (import wizard)
    step: 1,                    // 1=upload, 2=csv-map, 3=review, 4=done
    selectedFile: null,
    fileName: '',
    uploading: false,
    confirming: false,
    importResult: null,
    csvMapping: null,
    detectedColumns: [],
    suggestedMapping: null,
    sampleRows: [],
    showIgnored: false,
    filterMode: 'all',
    sortCol: 'date',
    sortDir: 'asc',
    rowDecisions: {},
    createEntryRow: null,
    createEntryForm: {account_id: '', location_id: '', memo: ''},
    dateFrom: '',
    dateTo: '',
    reRunningRules: false,
    groupSelection: {},
    groupEntryForm: {account_id: '', location_id: '', memo: ''},
    groupPosting: false,
  };

  private get apiBase(): string {
    return this.appConfig.apiBaseUrl;
  }

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private titleService: Title,
    private tableDataService: DataService,
    private notification: BsToastService,
    private appConfig: AppConfigService,
    private reportPrint: ReportPrintService,
    private confirmDialog: ConfirmDialogService,
  ) {
  }

  ngOnInit() {
    this.titleService.setTitle('Bank Import');
    this.loadBanks();
    this.loadLocations();

    // Support direct link via ?import_id=... (resume from external link)
    const qp = this.route.snapshot.queryParams;
    const importId = qp['import_id'];
    if (importId) {
      this.vm.bank_id = qp['bank_id'] || '';
      this.loadSession(importId);
    } else {
      // this.getHistory();
      this.historyLoaded = true;
    }
  }

  // ── Shared data loaders ────────────────────────────────────────────────────

  loadBanks() {
    this.tableDataService.getApiListData('bank', '?state=active&pageNumber=0&pageSize=999999').subscribe({
      next: (result: any) => {
        this.vm.banks = result.Data || [];
      },
      error: () => {
      }
    });
  }


  loadLocations() {
    this.tableDataService.getApiListData('location', '?pageNumber=0&pageSize=999999').subscribe({
      next: (result: any) => {
        this.vm.locations = result.Data || [];
      },
      error: () => {
      }
    });
  }

  onBankChange(bankId?: string) {
    const id = bankId || this.vm.bank_id;
    const bank = this.vm.banks.find((b: any) => b.id === id);
    if (bank) {
      this.vm.company_id = bank.company_id || '';
    }
    if (this.vm.activeTab === 'history') {
      this.historyPage = 1;
      this.getHistory();
    }
  }

  // ── History tab ────────────────────────────────────────────────────────────

  onHistoryStatusChange() {
    const f = this.vm.historyStatusFilter;
    this.vm.historyList = f
      ? this.vm.historyAllList.filter((r: any) => r.status === f)
      : [...this.vm.historyAllList];
  }

  getHistory() {

    this.historyLoaded = false;
    let params = `?pageNumber=${this.historyPage - 1}&pageSize=${this.historyPageSize}`;
    if (this.vm.bank_id) {
      params += `&bank_id=${this.vm.bank_id}`;
    }
    if (this.vm.company_id) {
      params += `&company_id=${this.vm.company_id}`;
    }
    console.log('[BankImport][getHistory] url:', this.apiBase + 'bank-import' + params);
    this.tableDataService.getApiListData('bank-import', params).subscribe({
      next: (result: any) => {
        console.log('[BankImport][getHistory] result:', result);
        this.vm.historyAllList = result.Data || result.data || [];
        this.vm.historyList = [...this.vm.historyAllList];
        this.vm.historyStatusFilter = '';
        this.historyTotalRecords = result.totalRecords || 0;
        this.historyLoaded = true;
      },
      error: () => {
        this.historyLoaded = true;
      }
    });
  }

  historyPaginate() {
    this.getHistory();
  }

  get historyStartIndex(): number {
    return (this.historyPage - 1) * this.historyPageSize + 1;
  }

  get historyEndIndex(): number {
    return Math.min(this.historyPage * this.historyPageSize, this.historyTotalRecords);
  }

  viewDetail(importId: string) {
    console.log('[BankImport][viewDetail] endpoint: bank-import, importId:', importId);
    console.log('[BankImport][viewDetail] full url:', this.apiBase + 'bank-import/' + importId);
    this.tableDataService.getData('bank-import', importId).subscribe({
      next: (result: any) => {
        console.log('[BankImport][viewDetail] result:', result);
        this.vm.historyDetail = result;
      },
      error: () => {
        this.notification.showErrorToast('Failed to load import detail.');
      }
    });
  }

  closeDetail() {
    this.vm.historyDetail = null;
  }

  printDetail() {
    const d = this.vm.historyDetail;
    if (!d) {
      return;
    }
    const dp = new DatePipe('en-US');
    const fmt = (v: number) => new DecimalPipe('en-US').transform(Math.abs(v), '1.2-2') || '0.00';
    const cell = (v: number) => v >= 0 ? fmt(v) : `(${fmt(v)})`;

    const rows = (d.items || []).map((item: any) => `
      <tr>
        <td>${dp.transform(item.date, 'MM/dd/yyyy') || ''}</td>
        <td>${item.description || ''}</td>
        <td style="text-align:right">${cell(item.amount)}</td>
        <td>${item.status || ''}</td>
        <td>${item.matched_check_number ? 'Check #' + item.matched_check_number : (item.matched_header_id ? item.matched_header_id.slice(0, 8) + '…' : '')}</td>
        <td>${item.suggested_type || ''}</td>
      </tr>`).join('');

    const meta = [
      {label: 'File', value: d.file_name || ''},
      {label: 'Imported', value: dp.transform(d.imported_at, 'MM/dd/yyyy h:mm a') || ''},
      {label: 'Status', value: d.status || ''},
      {label: 'Total Rows', value: String(d.total_rows || 0)},
      {label: 'Matched', value: String(d.matched_count || 0)},
      {label: 'Unmatched', value: String(d.unmatched_count || 0)},
    ];

    const contentHtml = `
      <table width="100%" style="border-spacing:0;border-collapse:collapse">
        <thead><tr>
          <th style="border-bottom:2px solid #ddd;padding:4px">Date</th>
          <th style="border-bottom:2px solid #ddd;padding:4px">Description</th>
          <th style="border-bottom:2px solid #ddd;padding:4px;text-align:right">Amount</th>
          <th style="border-bottom:2px solid #ddd;padding:4px">Status</th>
          <th style="border-bottom:2px solid #ddd;padding:4px">Matched To</th>
          <th style="border-bottom:2px solid #ddd;padding:4px">Type</th>
        </tr></thead>
        <tbody>${rows}</tbody>
      </table>`;

    const html = this.reportPrint.buildHtml({title: 'Bank Import Detail', contentHtml, meta, orientation: 'landscape'});
    this.reportPrint.printInIframe(html);
  }

  emailDetail() {
    const d = this.vm.historyDetail;
    if (!d) {
      return;
    }
    const dp = new DatePipe('en-US');
    const fmt = (v: number) => new DecimalPipe('en-US').transform(Math.abs(v), '1.2-2') || '0.00';
    const cell = (v: number) => v >= 0 ? fmt(v) : `(${fmt(v)})`;

    const rows = (d.items || []).map((item: any) => `
      <tr>
        <td>${dp.transform(item.date, 'MM/dd/yyyy') || ''}</td>
        <td>${item.description || ''}</td>
        <td style="text-align:right">${cell(item.amount)}</td>
        <td>${item.status || ''}</td>
        <td>${item.matched_check_number ? 'Check #' + item.matched_check_number : (item.matched_header_id ? item.matched_header_id.slice(0, 8) + '…' : '')}</td>
        <td>${item.suggested_type || ''}</td>
      </tr>`).join('');

    const meta = [
      {label: 'File', value: d.file_name || ''},
      {label: 'Imported', value: dp.transform(d.imported_at, 'MM/dd/yyyy h:mm a') || ''},
      {label: 'Status', value: d.status || ''},
      {label: 'Total Rows', value: String(d.total_rows || 0)},
      {label: 'Matched', value: String(d.matched_count || 0)},
      {label: 'Unmatched', value: String(d.unmatched_count || 0)},
    ];

    const contentHtml = `
      <table width="100%" style="border-spacing:0;border-collapse:collapse">
        <thead><tr>
          <th style="border-bottom:2px solid #ddd;padding:4px">Date</th>
          <th style="border-bottom:2px solid #ddd;padding:4px">Description</th>
          <th style="border-bottom:2px solid #ddd;padding:4px;text-align:right">Amount</th>
          <th style="border-bottom:2px solid #ddd;padding:4px">Status</th>
          <th style="border-bottom:2px solid #ddd;padding:4px">Matched To</th>
          <th style="border-bottom:2px solid #ddd;padding:4px">Type</th>
        </tr></thead>
        <tbody>${rows}</tbody>
      </table>`;

    const emailObj = new EmailModel();
    emailObj.toEmail = '';
    emailObj.fromEmail = '';
    emailObj.fromName = 'AcctXErp';
    emailObj.Subject = 'Bank Import Detail – ' + (d.file_name || '');
    emailObj.body = 'Please see the attached Bank Import Detail report.<br><br>Best regards,<br><br>AcctXErp<br><br>';
    emailObj.pdfHtml = this.reportPrint.buildHtml({title: 'Bank Import Detail', contentHtml, meta, orientation: 'landscape'});
    emailObj.print_orientation = '2';
    emailObj.convert_attachment_to = 'pdf';
    emailObj.FileName = `Bank_Import_Detail_${(d.import_id || '').slice(0, 8)}.pdf`;
    emailObj.activity_message = 'Bank Import Detail';
    emailObj.header_id = d.import_id || '';

    this.reportDataToSendInEmail = emailObj;

    let emailEl = (this.emailModalHost?.nativeElement as HTMLElement)?.querySelector?.('#sendEmailModal') || document.getElementById('sendEmailModal');
    if (emailEl) {
      const modal = new Modal(emailEl);
      modal.show();
    }
  }

  deleteHistory(importId: string) {
    this.confirmDialog.confirmThis(
      ['Delete this import?', 'All rows will be permanently removed.', 'danger:This action cannot be undone!'],
      () => {
        this.doDeleteHistory(importId);
      },
      () => {
      }
    );
  }

  private doDeleteHistory(importId: string) {
    this.tableDataService.deleteDataById('bank-import', importId).subscribe({
      next: () => {
        this.notification.showSuccessToast('Import deleted successfully.');
        this.vm.historyAllList = this.vm.historyAllList.filter((r: any) => r.import_id !== importId);
        this.vm.historyList = this.vm.historyList.filter((r: any) => r.import_id !== importId);
      },
      error: (err: HttpErrorResponse) => {
        const code = err.error?.error_code || err.error?.message || '';
        if (code === 'import_completed') {
          this.notification.showErrorToast('Completed imports cannot be deleted.');
        } else {
          this.notification.showErrorToast('Failed to delete import. Please try again.');
        }
      }
    });
  }

  promptReverse(importId: string) {
    this.vm.reverseConfirmImportId = importId;
  }

  cancelReverse() {
    this.vm.reverseConfirmImportId = null;
  }

  reverseImport(importId: string) {
    this.vm.reversing = true;
    this.tableDataService.post(`bank-import/${importId}/reverse`, {}).subscribe({
      next: () => {
        this.vm.reversing = false;
        this.vm.reverseConfirmImportId = null;
        this.vm.historyDetail = null;
        this.notification.showSuccessToast('Import reversed successfully.');
        this.getHistory();
      },
      error: (err: HttpErrorResponse) => {
        this.vm.reversing = false;
        this.notification.showErrorToast(err.error?.message || 'Reversal failed.');
      }
    });
  }

  resumeImport(row: any) {
    this.vm.bank_id = row.bank_id || '';
    const bank = this.vm.banks.find((b: any) => b.id === this.vm.bank_id);
    if (bank) {
      this.vm.company_id = bank.company_id || '';
    }
    this.loadSession(row.import_id);
  }

  startNewImport() {
    this.vm.step = 1;
    this.vm.selectedFile = null;
    this.vm.fileName = '';
    this.vm.importResult = null;
    this.vm.csvMapping = null;
    this.vm.rowDecisions = {};
    this.vm.createEntryRow = null;
    this.vm.dateFrom = '';
    this.vm.dateTo = '';
    this.vm.activeTab = 'work';
  }

  loadSession(importId: string) {
    this.tableDataService.getData('bank-import', importId).subscribe({
      next: (detail: any) => {
        this.vm.importResult = detail;
        this.vm.bank_id = this.vm.bank_id || detail.bank_id || '';
        this.vm.company_id = this.vm.company_id || detail.company_id || '';
        this.initDecisions(detail.items || []);
        this.vm.step = 3;
        this.vm.activeTab = 'work';
      },
      error: () => {
        this.notification.showErrorToast('Failed to load import session.');
      }
    });
  }

  // ── Work tab (import wizard) ───────────────────────────────────────────────

  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.storedFile = input.files[0];
      this.vm.selectedFile = this.storedFile;
      this.vm.fileName = input.files[0].name;
    }
  }

  get canUpload(): boolean {
    return !!this.vm.bank_id && !!this.vm.selectedFile;
  }

  upload() {
    if (!this.canUpload) {
      return;
    }
    this.vm.uploading = true;
    const formData = new FormData();
    formData.append('file', this.vm.selectedFile);
    formData.append('bank_id', this.vm.bank_id);
    formData.append('company_id', this.vm.company_id);
    if (this.vm.dateFrom) {
      formData.append('date_from', this.vm.dateFrom);
    }
    if (this.vm.dateTo) {
      formData.append('date_to', this.vm.dateTo);
    }

    console.log('[BankImport][upload] payload:', {
      file: this.vm.selectedFile?.name,
      bank_id: this.vm.bank_id,
      company_id: this.vm.company_id,
      date_from: this.vm.dateFrom || null,
      date_to: this.vm.dateTo || null,
      url: this.apiBase + 'bank-import/upload'
    });

    this.tableDataService.postFormData('bank-import/upload', formData).subscribe({
      next: (result: any) => {
        this.vm.uploading = false;
        if (result.status === 'mapping_required') {
          console.log('[BankImport][upload] mapping_required result:', result);
          this.vm.detectedColumns = result.detected_columns || [];
          this.vm.suggestedMapping = {...result.suggested_mapping};
          this.vm.csvMapping = {...result.suggested_mapping};
          if (!this.vm.csvMapping.amount_mode) {
            this.vm.csvMapping.amount_mode = 'signed';
          }
          this.vm.sampleRows = result.sample_rows || [];
          this.vm.importResult = result;
          this.vm.step = 2;
        } else {
          console.log('[BankImport][upload] result:', result);
          this.vm.importResult = result;
          this.initDecisions(result.items || []);
          this.vm.step = 3;
        }
      },
      error: (err: HttpErrorResponse) => {
        this.vm.uploading = false;
        this.notification.showErrorToast(err.error?.message || 'Upload failed. Please check the file and try again.');
      }
    });
  }

  confirmMapping() {
    const importId = this.vm.importResult?.import_id || this.vm.importResult?.id;
    console.log('[BankImport][confirmMapping] importId:', importId);
    this.vm.uploading = true;
    const formData = new FormData();
    formData.append('file', this.storedFile || this.vm.selectedFile);
    formData.append('bank_id', this.vm.bank_id);
    formData.append('company_id', this.vm.company_id);
    formData.append('import_id', importId);
    formData.append('csv_mapping', JSON.stringify(this.vm.csvMapping));
    if (this.vm.dateFrom) {
      formData.append('date_from', this.vm.dateFrom);
    }
    if (this.vm.dateTo) {
      formData.append('date_to', this.vm.dateTo);
    }

    this.tableDataService.postFormData('bank-import/upload', formData).subscribe({
      next: (result: any) => {
        console.log('[BankImport][confirmMapping] result:', result);
        this.vm.uploading = false;
        this.vm.importResult = result;
        this.initDecisions(result.items || []);
        this.vm.step = 3;
      },
      error: (err: HttpErrorResponse) => {
        this.vm.uploading = false;
        this.notification.showErrorToast(err.error?.message || 'Mapping confirmation failed.');
      }
    });
  }

  initDecisions(items: any[]) {
    this.vm.rowDecisions = {};
    for (const item of items) {
      if (item.status === 'matched' && item.match_confidence === 'high') {
        this.vm.rowDecisions[item.bank_import_transaction_id || item.id] = 'accept_match';
      }
    }
  }

  get filteredItems(): any[] {
    const items: any[] = this.vm.importResult?.items || [];
    const showIgnored = this.vm.showIgnored;
    const filterMode = this.vm.filterMode;
    const filtered = items.filter(i => {
      if (i.status === 'ignored' && !showIgnored) {
        return false;
      }
      if (filterMode === 'unmatched' && i.status !== 'unmatched' && !(i.status === 'ignored' && showIgnored)) {
        return false;
      }
      return true;
    });
    const col = this.vm.sortCol;
    const dir = this.vm.sortDir === 'asc' ? 1 : -1;
    return filtered.sort((a, b) => {
      let av = a[col] ?? '';
      let bv = b[col] ?? '';
      if (col === 'amount') {
        av = Number(av);
        bv = Number(bv);
      }
      if (av < bv) {
        return -1 * dir;
      }
      if (av > bv) {
        return 1 * dir;
      }
      return 0;
    });
  }

  sortBy(col: string) {
    if (this.vm.sortCol === col) {
      this.vm.sortDir = this.vm.sortDir === 'asc' ? 'desc' : 'asc';
    } else {
      this.vm.sortCol = col;
      this.vm.sortDir = 'asc';
    }
  }

  get allUnmatchedActioned(): boolean {
    const items: any[] = this.vm.importResult?.items || [];
    const unmatched = items.filter(i => i.status === 'unmatched');
    if (unmatched.length === 0) {
      return true;
    }
    return unmatched.every(i => !!this.vm.rowDecisions[i.bank_import_transaction_id || i.id]);
  }

  setDecision(item: any, action: string) {
    this.vm.rowDecisions[item.bank_import_transaction_id || item.id] = action;
    if (action === 'create_entry') {
      this.vm.createEntryRow = item;
      this.vm.createEntryForm = {account_id: '', location_id: '', memo: item.description || ''};
    } else {
      if ((this.vm.createEntryRow?.bank_import_transaction_id || this.vm.createEntryRow?.id) === (item.bank_import_transaction_id || item.id)) {
        this.vm.createEntryRow = null;
      }
    }
  }

  submitCreateEntry(item: any) {
    const importId = this.vm.importResult?.import_id;
    if (!importId) {
      return;
    }
    const bank = this.vm.banks.find((b: any) => b.id === this.vm.bank_id);
    const cashAccountId = bank?.gl_account_id || bank?.cash_account_id || null;
    const payload = {
      bank_import_transaction_id: item.bank_import_transaction_id || item.id,
      account_id: this.vm.createEntryForm.account_id,
      cash_account_id: cashAccountId,
      location_id: this.vm.createEntryForm.location_id || null,
      memo: this.vm.createEntryForm.memo || null
    };
    console.log('[BankImport][createEntry] payload:', payload);
    this.tableDataService.post(`bank-import/${importId}/create-entry`, payload).subscribe({
      next: () => {
        this.notification.showSuccessToast('Transaction entry created.');
        this.vm.rowDecisions[item.bank_import_transaction_id || item.id] = 'created';
        this.vm.createEntryRow = null;
        item.status = 'posted';
      },
      error: (err: HttpErrorResponse) => {
        this.notification.showErrorToast(err.error?.message || 'Failed to create entry.');
      }
    });
  }

  // ── Group (bulk) create-entry: lets the user post many like-kind unmatched
  // transactions (e.g. 50 misc office expense lines) to a single offsetting
  // account in one step, instead of repeating the Create Entry form per row.
  // Dates/amounts/descriptions for each row are preserved; only the offsetting
  // account/location (and optionally a shared memo) are applied in bulk. ──

  toggleGroupSelection(item: any) {
    const key = item.bank_import_transaction_id || item.id;
    if (this.vm.groupSelection[key]) {
      delete this.vm.groupSelection[key];
    } else {
      this.vm.groupSelection[key] = item;
      // Selecting rows for bulk grouping supersedes the single-row create-entry form.
      this.vm.createEntryRow = null;
    }
  }

  get selectedUnmatchedCount(): number {
    return Object.keys(this.vm.groupSelection || {}).length;
  }

  clearGroupSelection() {
    this.vm.groupSelection = {};
    this.vm.groupEntryForm = {account_id: '', location_id: '', memo: ''};
  }

  submitGroupEntries() {
    const importId = this.vm.importResult?.import_id;
    const items: any[] = Object.values(this.vm.groupSelection || {});
    if (!importId || items.length === 0 || !this.vm.groupEntryForm.account_id) {
      return;
    }
    const bank = this.vm.banks.find((b: any) => b.id === this.vm.bank_id);
    const cashAccountId = bank?.gl_account_id || bank?.cash_account_id || null;
    this.vm.groupPosting = true;

    const postNext = (index: number, successCount: number, failCount: number) => {
      if (index >= items.length) {
        this.vm.groupPosting = false;
        if (successCount > 0) {
          this.notification.showSuccessToast(`${successCount} transaction(s) posted to the selected account.`);
        }
        if (failCount > 0) {
          this.notification.showErrorToast(`${failCount} transaction(s) failed to post.`);
        }
        this.clearGroupSelection();
        return;
      }
      const item = items[index];
      const payload = {
        bank_import_transaction_id: item.bank_import_transaction_id || item.id,
        account_id: this.vm.groupEntryForm.account_id,
        cash_account_id: cashAccountId,
        location_id: this.vm.groupEntryForm.location_id || null,
        memo: this.vm.groupEntryForm.memo || item.description || null
      };
      console.log('[BankImport][submitGroupEntries] payload:', payload);
      this.tableDataService.post(`bank-import/${importId}/create-entry`, payload).subscribe({
        next: () => {
          this.vm.rowDecisions[item.bank_import_transaction_id || item.id] = 'created';
          item.status = 'posted';
          postNext(index + 1, successCount + 1, failCount);
        },
        error: () => {
          postNext(index + 1, successCount, failCount + 1);
        }
      });
    };

    postNext(0, 0, 0);
  }

  alwaysIgnore(item: any) {
    const bankId = this.vm.bank_id || this.vm.importResult?.bank_id || '';
    const companyId = this.vm.company_id || this.vm.importResult?.company_id || '';
    const payload = {
      bank_id: bankId,
      company_id: companyId,
      field: 'description',
      operator_type: 'contains',
      value: item.description,
      case_sensitive: false,
      note: 'Auto-created from import review'
    };
    console.log('[BankImport][alwaysIgnore] payload:', payload);
    item.status = 'ignored';
    this.vm.rowDecisions[item.bank_import_transaction_id || item.id] = 'ignored';
    this.tableDataService.post('bank-ignore-rules', payload).subscribe({
      next: () => {
        this.notification.showSuccessToast('Ignore rule created.');
        this.reRunRules();
      },
      error: () => {
        item.status = 'unmatched';
        delete this.vm.rowDecisions[item.bank_import_transaction_id || item.id];
        this.notification.showErrorToast('Failed to create ignore rule.');
      }
    });
  }

  reRunRules() {
    const importId = this.vm.importResult?.import_id;
    if (!importId) {
      return;
    }
    this.vm.reRunningRules = true;
    this.tableDataService.post(`bank-import/${importId}/re-run-rules`, {}).subscribe({
      next: (result: any) => {
        this.vm.reRunningRules = false;
        const newlyIgnored = result.newly_ignored || 0;
        if (newlyIgnored > 0) {
          this.notification.showSuccessToast(`${newlyIgnored} row(s) newly ignored by updated rules.`);
        }
        this.tableDataService.getData('bank-import', importId).subscribe({
          next: (detail: any) => {
            this.vm.importResult = detail;
            this.vm.bank_id = detail.bank_id || this.vm.bank_id;
            this.vm.company_id = detail.company_id || this.vm.company_id;
            this.initDecisions(detail.items || []);
          },
          error: () => {
          }
        });
      },
      error: () => {
        this.vm.reRunningRules = false;
        this.notification.showErrorToast('Failed to re-apply ignore rules.');
      }
    });
  }

  confirmImport() {
    const importId = this.vm.importResult?.import_id;
    if (!importId) {
      return;
    }
    this.vm.confirming = true;
    // Only send accept_match, skip, leave to the confirm endpoint.
    // create_entry rows are already posted via the create-entry endpoint individually.
    const allowedActions = new Set(['accept_match', 'skip', 'leave', 'unskip']);
    const rowDecisions = Object.entries(this.vm.rowDecisions)
      .filter(([, action]) => allowedActions.has(action as string))
      .map(([id, action]) => ({bank_import_transaction_id: id, action}));

    const payload = {import_id: importId, row_decisions: rowDecisions};
    console.log('[BankImport][confirmImport] endpoint:', `bank-import/${importId}/confirm`);
    console.log('[BankImport][confirmImport] payload:', JSON.stringify(payload, null, 2));

    this.tableDataService.post(`bank-import/${importId}/confirm`, payload).subscribe({
      next: () => {
        this.vm.confirming = false;
        this.vm.step = 4;
        this.notification.showSuccessToast('Import confirmed successfully.');
        this.getHistory();
      },
      error: (err: HttpErrorResponse) => {
        this.vm.confirming = false;
        this.notification.showErrorToast(err.error?.message || 'Confirm failed.');
      }
    });
  }

  startOver() {
    const importId = this.vm.importResult?.import_id;
    if (importId) {
      this.tableDataService.deleteDataById('bank-import', importId).subscribe({
        next: () => {
          this.notification.showSuccessToast('Import deleted. You can now upload a corrected file.');
          this.resetWizard();
        },
        error: (err: HttpErrorResponse) => {
          const code = err.error?.error_code || err.error?.message || '';
          if (code === 'import_completed') {
            this.notification.showErrorToast('This import has already been completed and cannot be deleted.');
          } else {
            this.notification.showErrorToast('Failed to delete import. Please try again.');
          }
        }
      });
    } else {
      this.resetWizard();
    }
  }

  private resetWizard() {
    this.vm.step = 1;
    this.vm.selectedFile = null;
    this.vm.fileName = '';
    this.vm.importResult = null;
    this.vm.csvMapping = null;
    this.vm.rowDecisions = {};
    this.vm.createEntryRow = null;
    this.vm.dateFrom = '';
    this.vm.dateTo = '';
  }

  doneGoToHistory() {
    this.resetWizard();
    this.vm.activeTab = 'history';
    this.getHistory();
  }

  // ── Badge helpers ──────────────────────────────────────────────────────────

  statusBadgeClass(status: string): string {
    switch (status) {
      case 'confirmed':
      case 'completed':
        return 'fpt-badge-success';
      case 'in_progress':
      case 'pending':
        return 'fpt-badge-warning';
      case 'reversed':
        return 'badge bg-danger text-white';
      default:
        return 'badge bg-light';
    }
  }

  itemStatusBadgeClass(status: string): string {
    switch (status) {
      case 'matched':
      case 'posted':
        return 'fpt-badge-success';
      case 'unmatched':
        return 'fpt-badge-warning';
      case 'duplicate':
      case 'skipped':
        return 'badge bg-secondary';
      case 'ignored':
        return 'badge bg-light text-muted';
      default:
        return 'badge bg-light';
    }
  }

  rowStatusBadgeClass(status: string): string {
    switch (status) {
      case 'matched':
        return 'fpt-badge-success';
      case 'unmatched':
        return 'fpt-badge-warning';
      case 'duplicate':
        return 'badge bg-secondary';
      case 'ignored':
        return 'badge bg-light text-muted';
      case 'posted':
        return 'fpt-badge-success';
      case 'skipped':
        return 'badge bg-secondary';
      default:
        return 'badge bg-light';
    }
  }

  amountClass(amount: number): string {
    return amount < 0 ? 'text-danger' : 'text-success';
  }
}
